import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { SwitcherOption } from './model/switcher-option.interface';

import { ISPFieldType } from '../../model';
import { ISPFieldTypeBase } from '../field-type-base.class';
import { autoPickSelectOptions } from '../select/select.utils';

/**
 * Switcher field component
 *
 * Use only with Formly
 */
@UntilDestroy()
@Component({
  selector: 'isp-formly-switcher-field',
  templateUrl: './switcher.component.html',
  styleUrls: ['./scss/switcher.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitcherFieldComponent
  extends ISPFieldTypeBase<ISPFieldType.Switcher>
  implements OnInit
{
  ngOnInit(): void {
    super.ngOnInit();

    this.props.options$.pipe(untilDestroyed(this)).subscribe(options => {
      autoPickSelectOptions(options, this.model, this.field);
    });
  }

  trackByOption(_: number, option: SwitcherOption): string {
    return `${option.value}${option.text}`;
  }
}
